import { Delete, Folder } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../components/CustomTable";
import DataTextField from "../components/DataInputs/DataTextField";
import FilterBase from "../components/Filter";
import usePagination from "../hooks/Pagination";
import {
	LetterTemplateFilter,
	LetterTemplateSearch,
	LetterTemplateTable,
} from "../interfaces/LetterTemplate";
import {
	ArrayContainer,
	Filter,
	Pagination,
	ResponseContainer,
	Sort,
} from "../interfaces/RequestBase";
import { TableTemplate } from "../interfaces/Table";
import {
	DeleteLetterTemplate,
	GetLetterTemplates,
} from "../requester/functions";
import getFilter from "../utilities/filter";

const LetterTemplatesPage = () => {
	const navigate = useNavigate();

	const [templates, setTemplates] = useState<LetterTemplateTable[]>([]);
	const [pagination, setPage, setPageSize] = usePagination();
	const [filter, setFilter] = useState<LetterTemplateFilter>({});
	const [search, setSearch] = useState<LetterTemplateSearch>({});
	const [sort, setSort] = useState<Sort>({});
	const [totalCount, setTotalCount] = useState<number>(0);

	const rows: TableTemplate = {
		data: [
			{
				title: "Название",
				key: "name",
				sortKey: "name",
			},
			{
				title: "",
				render: (item: LetterTemplateTable) => (
					<IconButton
						onClick={() => {
							navigate(`/template/${item.id}`);
						}}
					>
						<Folder />
					</IconButton>
				),
			},
			{
				title: "",
				render: (item: LetterTemplateTable) => (
					<IconButton
						onClick={() => {
							DeleteLetterTemplate({ id: item.id, is_delete: true }, () => {});
							getletterTemplates();
						}}
					>
						<Delete />
					</IconButton>
				),
			},
		],
	};

	const getTemplatesExport = (callback: any) => {
		var req: Filter<LetterTemplateFilter, LetterTemplateSearch> = getFilter(
			{ page: 0, size: totalCount } as Pagination,
			filter,
			search,
			sort
		);
		GetLetterTemplates(
			req,
			(resp: ResponseContainer<ArrayContainer<LetterTemplateTable>>) => {
				if (resp.status === "ok" && resp.data) {
					callback(resp.data.data);
				}
			}
		);
	};

	const getletterTemplates = () => {
		var req: Filter<LetterTemplateFilter, LetterTemplateSearch> = getFilter(
			pagination as Pagination,
			filter,
			search,
			sort
		);
		GetLetterTemplates(
			req,
			(resp: ResponseContainer<ArrayContainer<LetterTemplateTable>>) => {
				if (resp.status === "ok" && resp.data) {
					setTemplates(resp.data.data);
					setTotalCount(resp.data?.total_count || 0);
				}
			}
		);
	};

	useEffect(() => {
		getletterTemplates();
	}, [filter, pagination, search, sort]);

	return (
		<div className="flex flex-col gap-5">
			<div className="flex justify-between w-full">
				<Button
					onClick={() => {
						navigate("/template/create");
					}}
				>
					Создать
				</Button>
				<FilterBase setSearch={setSearch} setFilter={setFilter}>
					<DataTextField
						keyValue={"name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск шаблона" }}
					/>
				</FilterBase>
			</div>
			<CustomTable
				rows={rows}
				data={templates}
				allCount={totalCount}
				pagination={pagination as Pagination}
				setPage={setPage as (p: number) => void}
				setPageSize={setPageSize as (p: number) => void}
				sort={sort}
				setSort={setSort}
				onExport={getTemplatesExport}
			/>
		</div>
	);
};

export default LetterTemplatesPage;
